import React from 'react';
import { Flag, Paintbrush, Ruler, Phone } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="bg-charcoal text-cream py-1.5 border-b border-charcoal-light" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-x-6 gap-y-1 text-xs font-medium tracking-wide" data-id="element-105">
          <div className="flex-1 text-center md:text-left" data-id="element-106">
            <span data-id="element-107">
              Decorative Light Switch Plates &amp; Outlet Covers in Nearly Every
              Size — Handmade in the USA with Matching Screws Included.
            </span>
          </div>
          <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-108">
            <Phone size={12} className="text-gold" data-id="element-109" />
            <a href="tel:8004976946" className="hover:text-gold transition-colors" data-id="element-110">
              800.497.6946
            </a>
          </div>
        </div>
      </div>
    </div>;
}